import React, { useContext, useEffect, useState } from "react";
import useSnackbar from "./../../../hooks/useSnackbar";
import { useParams, useSearchParams } from "react-router-dom";
import _ from "lodash";

import {
  Button,
  Divider,
  Grid,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  Typography,
  colors,
  TablePagination,
  Paper,
  IconButton,
  TextField
} from "@mui/material";

import { DateTimePicker } from "@mui/x-date-pickers";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"; // or any other adapter like AdapterDateFns
import dayjs from "dayjs";

import { useTheme } from "@mui/material/styles";

import Add from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import SyncIcon from "@mui/icons-material/Sync";
import UpgradeIcon from "@mui/icons-material/Upgrade";

import AlertDialog from "../../../components/Dialogs/AlertDialog";
import ContainerLoading from "../../../components/Loading/ContainerLoading";

//import UserRow from "./Users/UserRow";
import CharityRow from "./Charities/CharityRow";

import CreateCharityDialog from "./Charities/CreateCharityDialog";
import EditAllCharityDialog from "./Charities/EditAllCharityDialog";

import SearchDropdown from "./Charities/SearchDropdown";

import HttpContext from "../../../contexts/HTTP/HttpContext";

function Charities() {
  const theme = useTheme();
  const { get, post } = useContext(HttpContext);

  const [loading, setLoading] = useState(true);

  const [charities, setCharities] = useState(null);

  const [editTargetCharity, setEditTargetCharity] = useState(null);

  // const [searchParams] = useSearchParams();
  // const name = searchParams.get("name");
  // const scope = searchParams.get("scope");
  const [filterStartDate, setFilterStartDate] = useState(dayjs());
  const [filterEndDate, setFilterEndDate] = useState(dayjs());
  const [filterKioskID, setFilterKioskID] = useState(null); //TODO CHange
  const [filterEvent, setFilterEvent] = useState(null); //TODO CHange
  const [filterCharityName, setFilterCharityName] = useState(null);
  const [filterCharityAddress, setFilterCharityAddress] = useState(null);
  const [filterHasLogo, setFilterHasLogo] = useState(null);
  const [filterHasPIN, setFilterHasPIN] = useState(null);

  const [paginationTotalItems, setPaginationTotalItems] = useState(0);
  const [paginationPage, setPaginationPage] = useState(0);
  const [paginationLimit, setPaginationLimit] = useState(25);
  const [paginationTotalPages, setPaginationTotalPages] = useState(0);

  const [createCharityDialogOpened, setCreateCharityDialogOpened] = useState(
    false
  );
  const [showUpdateAllDialog, setShowUpdateAllDialog] = useState(false);
  const [showFullSyncDialog, setShowFullSyncDialog] = useState(false);

  const { openSnackbar } = useSnackbar();

  const performActionGlobalCollectorSync = async () => {
    setShowFullSyncDialog(false);
    setLoading(true); //loadKeys will set loading to false;
    const res = await post("/synccharities/");
    const results = res.data;
    console.log("[DEBUG] res", res);

    if (res.status !== 200) {
      openSnackbar({
        open: true,
        message: "Unable to sync.",
        variant: "alert",
        alert: {
          color: "error"
        },
        close: false
      });
      setLoading(false);
      return;
    }

    let successMessage = "";
    if (results.updated) {
      successMessage =
        successMessage + results.updated.toString() + " Updated successfully!";
    }
    if (results.added) {
      successMessage =
        successMessage + results.added.toString() + " Added successfully!";
    }
    if (!results.updated && !results.added) {
      successMessage = successMessage + "Sync successful with no changes!";
    }

    openSnackbar({
      open: true,
      message: successMessage,
      variant: "alert",
      alert: {
        color: "success"
      },
      close: false
    });

    await loadData();
  };

  const refreshTable = async (newpage, newlimit) => {
    setLoading(true);

    let url = "/charities";
    let searchparams =
      "?page=" +
      newpage +
      "&limit=" +
      newlimit +
      "&skip=" +
      ((newpage - 1) * newlimit).toString();

    if (filterCharityName != null) {
      searchparams = searchparams + "&name=" + filterCharityName;
    }

    if (filterCharityAddress != null) {
      searchparams = searchparams + "&address=" + filterCharityAddress;
    }

    if (filterHasLogo != null) {
      searchparams = searchparams + "&hasLogo=" + filterHasLogo;
    }

    if (filterHasPIN != null) {
      searchparams = searchparams + "&hasPIN=" + filterHasPIN;
    }

    //Load data
    const res2 = await get("/charities" + searchparams);

    if (res2.status !== 200) {
      openSnackbar({
        open: true,
        message: "Unable to load user data",
        variant: "alert",
        alert: {
          color: "error"
        },
        close: false
      });
    }

    if (res2.status == 403 || res2.status == 401) {
      //logout and redirect to login
      await get("/logout");
      localStorage.removeItem("accessToken");
      window.location.href = "/login";
    }

    if (res2.status === 200) {
      const data = _.get(res2, "data");

      console.log("[DEBUG] data.pagination", data.pagination);

      if (data.pagination) {
        setPaginationTotalItems(data.pagination.totalItems);
        setPaginationPage(data.pagination.currentPage);
        setPaginationLimit(data.pagination.itemsPerPage);
        setPaginationTotalPages(data.pagination.totalItems);
      }

      await setCharities(data.charities);
    }

    setLoading(false);
  };

  const loadData = async () => {
    await refreshTable(paginationPage, paginationLimit);
    // setLoading(true);

    // let url = "/charities";
    // let searchparams =
    //   "?page=" +
    //   paginationPage +
    //   "&limit=" +
    //   paginationLimit +
    //   "&skip=" +
    //   ((paginationPage - 1) * paginationLimit).toString();

    // //Load data
    // const res2 = await get("/charities" + searchparams);

    // if (res2.status !== 200) {
    //   openSnackbar({
    //     open: true,
    //     message: "Unable to load user data",
    //     variant: "alert",
    //     alert: {
    //       color: "error"
    //     },
    //     close: false
    //   });
    // }

    // if (res2.status == 403 || res2.status == 401) {
    //   //logout and redirect to login
    //   await get("/logout");
    //   localStorage.removeItem("accessToken");
    //   window.location.href = "/login";
    // }

    // if (res2.status === 200) {
    //   const data = _.get(res2, "data");

    //   console.log("[DEBUG] data.pagination", data.pagination);

    //   if (data.pagination) {
    //     setPaginationTotalItems(data.pagination.totalItems);
    //     setPaginationPage(data.pagination.currentPage);
    //     setPaginationLimit(data.pagination.itemsPerPage);
    //     setPaginationTotalPages(data.pagination.totalItems);
    //   }

    //   await setCharities(data.charities);
    // }

    // setLoading(false);
  };

  const handleChangePage = async (event, newPage) => {
    await setPaginationPage(newPage);
    await refreshTable(newPage, paginationLimit);
  };

  const handleChangeRowsPerPage = async event => {
    const newlimit = parseInt(event.target.value, 10);
    await setPaginationLimit(newlimit);
    await setPaginationPage(0);
    await refreshTable(0, newlimit);
  };

  const handleSaveEditChanges = async payload => {
    //console.log("payload", payload);

    if (!payload) {
      openSnackbar({
        open: true,
        message: "Invalid payload.",
        variant: "alert",
        alert: {
          color: "error"
        },
        close: false
      });
      return;
    }

    console.log("[DEBUG] charities.js payload", payload);

    if (payload.charityID == null) {
      openSnackbar({
        open: true,
        message: "Invalid charity ID. Please select a valid charity ID.",
        variant: "alert",
        alert: {
          color: "error"
        },
        close: false
      });
      return;
    }

    const res2 = await post("/charities", payload);

    if (res2.status !== 200) {
      openSnackbar({
        open: true,
        message: "Unable to save changes.",
        variant: "alert",
        alert: {
          color: "error"
        },
        close: false
      });
      //setCreateCharityDialogOpened(false);
      return;
    }

    openSnackbar({
      open: true,
      message: "Changes saved successfully!",
      variant: "alert",
      alert: {
        color: "success"
      },
      close: false
    });
    setCreateCharityDialogOpened(false);
    await loadData();
  };

  const handleUpdateAllCharities = async payload => {
    //console.log("payload", payload);

    if (!payload) {
      openSnackbar({
        open: true,
        message: "Invalid payload.",
        variant: "alert",
        alert: {
          color: "error"
        },
        close: false
      });
      return;
    }

    console.log("[DEBUG] charities.js payload", payload);

    const res2 = await post("/allcharities", payload);

    if (res2.status !== 200) {
      openSnackbar({
        open: true,
        message: "Unable to save changes.",
        variant: "alert",
        alert: {
          color: "error"
        },
        close: false
      });

      return;
    }

    openSnackbar({
      open: true,
      message: "Changes saved successfully!",
      variant: "alert",
      alert: {
        color: "success"
      },
      close: false
    });
    setShowUpdateAllDialog(false);
    await loadData();
  };

  const handleActionEdit = row => {
    setEditTargetCharity(row);
    setCreateCharityDialogOpened(true);
  };

  useEffect(() => {
    (async () => {
      await loadData();
    })();
  }, []);

  return (
    <Grid
      style={{
        margin: theme.spacing(2),
        padding: theme.spacing(3),
        width: "100%",
        backgroundColor: colors.grey[100],
        borderRadius: "10px"
      }}
    >
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <div style={{ display: "flex", flexDirection: "column" }}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              marginBottom: theme.spacing(2)
            }}
          >
            <Typography variant="h4">Charities</Typography>
            <Typography variant="h5" style={{ marginLeft: theme.spacing(2) }}>
              {paginationTotalItems ? (
                <span style={{ color: "grey" }}>
                  ({paginationTotalItems} result
                  {paginationTotalItems == 1 ? "" : "s"})
                </span>
              ) : (
                <></>
              )}
            </Typography>
          </div>
          {/* <Typography>View and delete your Users</Typography> */}
        </div>
      </div>
      {/* <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "flex-end",
          marginTop: theme.spacing(2)
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            gap: theme.spacing(1)
          }}
        >
          <Button
            variant="contained"
            onClick={() => {
              setEditTargetCharity(null);
              setCreateCharityDialogOpened(true);
            }}
            disabled={loading}
          >
            <Add style={{ marginRight: theme.spacing(1) }} />
            Add Charity
          </Button>
        </div>
      </div> */}
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          marginTop: theme.spacing(2)
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            gap: theme.spacing(1)
          }}
        >
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            {/* <DateTimePicker
              label="Start Date"
              value={filterStartDate}
              onChange={newValue => {
                console.log("DateTimePicker", newValue);
                setFilterStartDate(newValue);
              }}
            />
            <DateTimePicker
              label="End Date"
              value={filterEndDate}
              onChange={newValue => {
                console.log("DateTimePicker", newValue);
                setFilterEndDate(newValue);
              }}
            /> */}
          </LocalizationProvider>
          <TextField
            id="cname"
            label="Name"
            value={filterCharityName}
            onChange={event => {
              let newText = event.target.value;
              newText = newText.trim();
              setFilterCharityName(newText);
            }}
          />
          <TextField
            id="caddress"
            label="Address"
            value={filterCharityAddress}
            onChange={event => {
              let newText = event.target.value;
              newText = newText.trim();
              setFilterCharityAddress(newText);
            }}
          />
          <SearchDropdown
            label="Logo"
            value={filterHasLogo}
            onChange={(e, val) => {
              setFilterHasLogo(val);
            }}
          />
          <SearchDropdown
            label="PIN"
            value={filterHasPIN}
            onChange={(e, val) => {
              setFilterHasPIN(val);
            }}
          />
        </div>
        <div
          style={{
            marginLeft: "9px",
            display: "flex",
            flexWrap: "wrap",
            rowGap: "9px" /* This adds vertical space between rows */,
            columnGap: "9px" /* Optional: horizontal space between items */
          }}
        >
          <Button
            //style={{ marginLeft: "9px" }}
            variant="contained"
            onClick={() => {
              setEditTargetCharity(null);
              setCreateCharityDialogOpened(true);
            }}
            disabled={loading}
          >
            <Add style={{ marginRight: theme.spacing(1) }} />
            Add Charity
          </Button>
          <Button
            //style={{ marginLeft: "9px" }}
            variant="contained"
            onClick={async () => await refreshTable(0, paginationLimit)}
            disabled={loading}
          >
            <SearchIcon />
            Search
          </Button>
          <Button
            //style={{ marginLeft: "9px" }}
            variant="contained"
            color="secondary"
            onClick={() => setShowUpdateAllDialog(true)}
            disabled={loading}
          >
            <UpgradeIcon style={{ marginRight: theme.spacing(1) }} />
            Update All
          </Button>
          <Button
            //style={{ marginLeft: "9px", marginTop: "9px" }}
            variant="contained"
            color="warning"
            onClick={() => setShowFullSyncDialog(true)}
            disabled={loading}
          >
            <SyncIcon style={{ marginRight: theme.spacing(1) }} />
            Full Sync
          </Button>
        </div>
      </div>

      <Divider
        style={{ marginBottom: theme.spacing(2), marginTop: theme.spacing(2) }}
      />
      <ContainerLoading show={loading} />
      <TableContainer>
        <Table
          style={{
            marginTop: theme.spacing(2),
            display: loading ? "none" : null
          }}
        >
          <TableHead>
            <TableRow>
              <TableCell align="center">Enabled</TableCell>
              <TableCell align="left">Name</TableCell>
              <TableCell align="left">Logo</TableCell>
              <TableCell align="left">Pin</TableCell>
              <TableCell align="left">Address</TableCell>
              <TableCell align="left">Scope</TableCell>
              <TableCell align="left">Last Updated By</TableCell>
              <TableCell align="left">Last Updated At</TableCell>
              <TableCell align="center">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {charities !== null ? (
              charities.map(row => (
                <CharityRow row={row} handleActionEdit={handleActionEdit} />
              ))
            ) : (
              <></>
            )}
          </TableBody>
        </Table>
        <TablePagination
          component="div"
          count={paginationTotalItems}
          page={paginationPage}
          onPageChange={handleChangePage}
          rowsPerPage={paginationLimit}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </TableContainer>
      <CreateCharityDialog
        charity={editTargetCharity}
        open={createCharityDialogOpened}
        handleClose={() => setCreateCharityDialogOpened(false)}
        handleSaveEditChanges={handleSaveEditChanges}
      />
      {/* // */}
      <EditAllCharityDialog
        open={showUpdateAllDialog}
        handleClose={() => setShowUpdateAllDialog(false)}
        handleSaveEditChanges={handleUpdateAllCharities}
      />
      <AlertDialog
        open={showFullSyncDialog}
        handleConfirm={performActionGlobalCollectorSync}
        handleClose={() => setShowFullSyncDialog(false)}
        title="Full Sync"
        confirmButtonName="Confirm"
        closeButtonName="Cancel"
      >
        <Typography style={{ marginBottom: theme.spacing(2) }}>
          Are you sure you would like to perform a sync and update all
          charities?
        </Typography>
      </AlertDialog>
    </Grid>
  );
}

export default Charities;
